import styled, { css, DefaultTheme } from 'styled-components';

export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
  return css`
    position: absolute;

    &[data-position='TopLeft'],
    &[data-position='CenterLeft'],
    &[data-position='TopRight'],
    &[data-position='CenterRight'] {
      @media ${theme.mq.max.tablet} {
        top: 4.5em;
        left: 1em;
      }
    }

    &[data-position='BottomLeft'],
    &[data-position='BottomRight'] {
      @media ${theme.mq.max.tablet} {
        bottom: 4.5em;
        left: 1em;
      }
    }
  `;
  }};
`;
